import React, { useState, useEffect, useContext } from "react";
import styles from "./CountDownWithMinutes.module.css";
import Context from "../../context/Context";

function CountDownWithMinutes({
  handleSubmit,
  time,
  buttonColor,
  setIntervalId,
  setQuizReadOnly,
}) {
  const [secLeft, setSecLeft] = useState(time * 60);
  const [timeLeft, setTimeLeft] = useState({});
  const { setTimeTaken } = useContext(Context);
  useEffect(() => {
    const intervalIdNew = setInterval(() => {
      setSecLeft((prev) => prev - 1);
    }, 1000);
    setIntervalId(intervalIdNew);
    return () => clearInterval(intervalIdNew);
  }, []);

  useEffect(() => {
    setTimeLeft(getTimeLeft(secLeft));
  }, [secLeft]);

  function getTimeLeft(totalSeconds) {
    if (totalSeconds <= 0) {
      setQuizReadOnly(true);
      handleSubmit();
      return {
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    setTimeTaken(time * 60 - totalSeconds);
    return {
      hours,
      minutes,
      seconds,
      totalSeconds,
    };
  }
  return (
    <div className="flex flex-col items-center justify-center ">
      <div className={styles.counterParent} style={{ color: buttonColor }}>
        {timeLeft?.totalSeconds >= 0 ? (
          <>
            <div className="text-large-medium">
              {timeLeft?.hours} <span className="text-smallest">Hrs</span>
            </div>
            <div className="text-large-medium">
              {timeLeft?.minutes} <span className="text-smallest">Min</span>
            </div>
            <div className="text-large-medium">
              {timeLeft?.seconds} <span className="text-smallest">Sec</span>
            </div>
          </>
        ) : (
          <p className="text-regular-bold">Submission period ended</p>
        )}
      </div>
    </div>
  );
}

export default CountDownWithMinutes;
